import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.date.to-string.js";
import exchangeBuryPoint from '../utils/exchangeBuryPoint';
import isMiniProgram from '../utils/isMiniProgram';
/**
 * 获取地址参数
 * @param name
 * @returns {null}
 * @private
 */

function _getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.slice(1).match(reg);
  return r != null ? unescape(r[2]) : null;
}

function BuryPoint() {
  this.config();
  this.init(this.defaultOptions);
}
/**
 * 埋点参数配置
 */


BuryPoint.prototype.config = function () {
  // 神策配置
  var serverUrl = '';
  var pageMeta = window.__PAGE_META__;

  if (pageMeta && pageMeta.env == 'testing' || process.env.NODE_ENV === 'development' || _getQueryString('isDebug') == 1) {
    // 测试环境
    serverUrl = 'https://shencedatareport.zhaoliangji.com/sa?project=default';
  } else {
    // 正式环境
    serverUrl = 'https://shencedatareport.zhaoliangji.com/sa?project=production';
  } // 神策SDK埋点


  var sdkUrl = 'https://frontstatic.zhaoliangji.com/static/js/shence/sensorsdata.min.js';
  this.sensorsOps = {
    sdk_url: sdkUrl,
    name: 'sensors',
    server_url: serverUrl,
    // 配置打通 App 与 H5 的参数
    use_app_track: true,
    heatmap: {
      // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      // 需要 JSSDK 版本号大于 1.7
      clickmap: 'not_collect',
      // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      // 需要 JSSDK 版本号大于 1.9.1
      scroll_notice_map: 'not_collect'
    }
  };
};
/**
 * 初始化
 */


BuryPoint.prototype.init = function () {
  this.sensors(this.sensorsOps);
};
/**
 * 神策埋点
 * @param para
 * @returns {boolean}
 */


BuryPoint.prototype.sensors = function (para) {
  var p = para.sdk_url;
  var n = para.name;
  var w = window;
  var d = document;
  var s = 'script';
  var x = null;
  var y = null;

  if (typeof w.sensorsDataAnalytic201505 !== 'undefined') {
    return false;
  }

  w.sensorsDataAnalytic201505 = n;

  w[n] = w[n] || function (a) {
    return function () {
      (w[n]._q = w[n]._q || []).push([a, arguments]);
    };
  };

  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];

  for (var i = 0; i < ifs.length; i++) {
    w[n][ifs[i]] = w[n].call(null, ifs[i]);
  }

  if (!w[n]._t) {
    // eslint-disable-next-line no-unused-expressions
    x = d.createElement(s);
    y = d.getElementsByTagName(s)[0];
    x.async = 1;
    x.src = p;
    w[n].para = para;
    y.parentNode.insertBefore(x, y);
  }
};
/**
 * 发送数据
 * @param params
 */


BuryPoint.prototype.send = function (publicData, name, params) {
  var gid = _getQueryString('gid');

  if (gid && params) params.group_id = gid;
  params = _extend(true, {}, publicData, params); // eslint-disable-next-line no-undef

  if (window.sensors) sensors.track(name, params);
};
/**
 * 合并对象
 * @param target
 * @param source
 * @returns {*}
 */


export function _extend(target) {
  var deep;

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  var args = rest || [];

  if (typeof target == 'boolean') {
    deep = target;
    target = args.shift();
  }

  args.forEach(function (arg) {
    copyToTarget(target, arg, deep);
  });
  return target;
}
/**
 * 深浅拷贝
 * @param target
 * @param source
 * @returns {*}
 */

export function copyToTarget(target) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var deep = arguments.length > 2 ? arguments[2] : undefined;

  for (var key in source) {
    if (deep && (isObject(source[key]) || isArray(source[key]))) {
      if (isObject(source[key]) && !isObject(target[key])) target[key] = {};
      if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
      copyToTarget(target[key], source[key], deep);
    } else if (source[key] !== undefined) target[key] = source[key];
  }
} // 判断是否是数组

export function isArray(arg) {
  return toString.call(arg) === '[object Array]';
} // 判断是否是对象

export function isObject(arg) {
  return toString.call(arg) === '[object Object]';
} // 当前神策埋点的对象实例，是不是在初始化中。不在初始化中，有两种可能，一是还未开始初始化。另一种是已经初始化完毕

var isBuryPointInitializing = false;
var buryPointList = [];
var buryPoint = null;
export default function buryPointSend(publicData, name, params) {
  try {
    if (!publicData || !name) {
      console.error("\u57CB\u70B9\u4FE1\u606F\u7F3A\u5C11\u5FC5\u8981\u7684\u53C2\u6570 publicData: ".concat(JSON.stringify(publicData), " name:").concat(name));
      return;
    }

    buryPointList = buryPointList.filter(function (item) {
      return !item.isSended;
    }); // 先把当前的埋点信息存储在内存队列中

    buryPointList.push({
      publicData: publicData,
      name: name,
      params: params,
      isSended: false
    });

    if (isBuryPointInitializing) {
      // 神策埋点对象在初始化过程中，直接返回即可。初始化好的对象会自动发送buryPointList中的埋点。
      console.log('神策埋点SDK初始化中,不必重复初始化');
      return;
    }

    if (buryPoint) {
      sendPoint();
    } else {
      isBuryPointInitializing = true;
      setTimeout(function () {
        var start = new Date().getTime();
        buryPoint = new BuryPoint();
        var end = new Date().getTime();
        console.log("\u521D\u59CB\u5316buryPoint\u5BF9\u8C61\u8017\u65F6:".concat(end - start, "ms"));
        isBuryPointInitializing = false;
        sendPoint();
      }, 0);
    }
  } catch (error) {
    console.error('[神策埋点对象初始化异常]', error);
  }
}

function sendPoint() {
  try {
    // 发送埋点信息
    buryPointList.forEach(function (item) {
      var publicData = item.publicData,
          name = item.name,
          _item$params = item.params,
          params = _item$params === void 0 ? {} : _item$params,
          isSended = item.isSended;

      if (!isSended) {
        item.isSended = true; // 神策埋点

        if (isMiniProgram()) {
          var exchangeData = exchangeBuryPoint({
            publicData: publicData,
            name: name,
            params: params
          }) || {};
          buryPoint.send(exchangeData.publicData, exchangeData.name, exchangeData.params);
        } else {
          buryPoint.send(publicData, name, params);
        }
      }
    });
  } catch (error) {
    console.error('[神策埋点发送出现异常]', error);
  }
}